import React, { useState } from "react";
import "./css/Contacts.css";

function Contact() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Submit Form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.mobile || !formData.message) {
      alert("Please fill all fields");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch("https://procure4eu.com/backend/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      const data = await res.json();

      alert(data.message);

      // Reset form
      setFormData({
        name: "",
        email: "",
        mobile: "",
        message: ""
      });

    } catch (error) {
      console.error(error);
      alert("Error sending message ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>

      <div className="contact-container">

        <h1>Contact Us</h1>

        <p className="contact-subtitle">
          Get in touch with us for projects, training, or any queries.
          We provide services online and offline across state, national, and international levels.
        </p>

        <div className="contact-flex">

          {/* FORM */}
          <form className="contact-form" onSubmit={handleSubmit}>

            <h2>Send Message</h2>

            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
            />

            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
            />

            <input
              type="text"
              name="mobile"
              placeholder="Mobile Number"
              value={formData.mobile}
              onChange={handleChange}
            />

            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
            ></textarea>

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>

          </form>

          {/* CONTACT INFO */}
          <div className="contact-info">

            <h2>Contact Information</h2>

            <p><b>📍 Address:</b> Dharwad, Karnataka – 580001</p>
            <p><b>📞 Phone:</b> +91 8884707098</p>
            <p><b>✉ Email:</b> mailtovikasdoddamani@gmail.com</p>

            <div className="contact-extra">
              <p>✔ Available Online & Offline</p>
              <p>✔ State, National & International Services</p>
            </div>

          </div>

        </div>

      </div>

    </div>
  );
}

export default Contact;